import { Anchor, Breadcrumbs, Button, Group } from "@mantine/core";
import { IconArrowBack } from "@tabler/icons-react";
import { PropsWithChildren, useCallback } from "react";
import { NavLink, useNavigate } from "react-router-dom";

type BreadcrumbsNavigationProperties = PropsWithChildren & {
  notHome?: boolean;
  /** Specific route to navigate back to (fallback when history is empty) */
  backTo?: string;
};

const BreadcrumbsNavigation = ({ children, notHome, backTo }: BreadcrumbsNavigationProperties) => {
  const navigate = useNavigate();

  /**
   * Handles the back button click.
   * Uses history if available, otherwise navigates to backTo route or home.
   */
  const handleBackClick = useCallback(() => {
    // Check if there's history to go back to
    // window.history.length > 1 means there's at least one page to go back to
    // But this isn't always reliable, so we also check if we can detect the referrer
    if (window.history.length > 2) {
      navigate(-1);
    } else if (backTo) {
      navigate(backTo);
    } else {
      // Fallback to home
      navigate("/");
    }
  }, [navigate, backTo]);

  return (
    <Group my="lg">
      <Button size="xs" onClick={handleBackClick} leftSection={<IconArrowBack size="1rem" />}>
        Voltar
      </Button>

      <Breadcrumbs>
        {!notHome && (
          <Anchor component={NavLink} to="/">
            Home
          </Anchor>
        )}
        {children}
      </Breadcrumbs>
    </Group>
  );
};

export default BreadcrumbsNavigation;
